import React from 'react';

const EmailConfirmationModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 text-center">
        <div className="mb-6">
          <div className="text-6xl mb-4">📩</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Check Your Email 📩
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Your login credentials have been sent to your registered email address. 
            Please check your inbox or spam folder.
          </p>
        </div>
        
        <button
          id="closeModal"
          onClick={onClose}
          className="bg-[#2f345d] hover:bg-[#455093] text-white px-6 py-3 rounded-lg font-semibold transition-all duration-200"
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default EmailConfirmationModal;
